import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ProjectCategoryConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ProjectCategoryService } from './api/projectCategory.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ProjectCategoryApiModule {
    public static forRoot(configurationFactory: () => ProjectCategoryConfiguration): ModuleWithProviders<ProjectCategoryApiModule> {
        return {
            ngModule: ProjectCategoryApiModule,
            providers: [ { provide: ProjectCategoryConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ProjectCategoryApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ProjectCategoryApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
